window.Vue = require('vue');

Vue.config.productionTip = false;
window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

var token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

window.$ = window.jQuery = require('jquery');

$(document).ajaxSend(function(event, jqxhr, settings) {
    jqxhr.setRequestHeader(
        "X-CSRF-TOKEN",
        $('meta[name="csrf-token"]').attr("content")
    );
});
window.Popper = require('popper.js').default;
require('bootstrap');

require('select2');

require('./vendor/xzoom');


// WEBPACK FOOTER //
// ./resources/assets/js/loja/vendor.js